import React, { useState } from "react";
import TableComponent from "../../../components/TableComponent/TableComponentFiltro";

export const Incapacidades = () => {
  const cabeceras = [
    "Id", //0
    "Nombre", //1
    "Editar",
    "Eliminar",
  ];
  const [parametros] = useState({
    action: "datatable",
    table: "types_incapacitys",
    rows: "keyTypeIncapacity,nameTypeIncapacity", ///sin espacios y comas
    conditions: "enabled = 1",
    page: 0,
    records: 5,
    search: "",
    order: "",
  });

  return (
    <div>
      <TableComponent
        titulo="Tipos de Incapacidades"
        cabecerasTabla={cabeceras}
        filtro={null}
        rutaCrear="/template/incapacidades-nomina/crear"
        rutaEditar="/template/incapacidades-nomina/editar"
        parametros={parametros}
      ></TableComponent>
    </div>
  );
};
export default Incapacidades;
